import React, { useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { AxiosError } from 'axios';
import classnames from 'classnames';
import { Card, Container } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { Redirect, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import BackgroundImages from 'v2/common/Background/BackgroundImages';
import Input from 'v2/form/Input/Input';
import { RootState, User } from 'v2/models';
import restFactory from 'v2/utils/restFactory';
import * as yup from 'yup';
import nomadLogo from '../../images/nomadLogo.svg';
import styles from './signUpInvite.module.scss';

type InviteUserData = Pick<User, 'first_name' | 'last_name' | 'job_title'>;

export const INVITE_SIGN_UP_DEFAULT_VALUES = {
  first_name: '',
  last_name: '',
  job_title: '',
};

const schema = yup.object().shape({
  first_name: yup.string().required('Required'),
  last_name: yup.string().required('Required'),
  job_title: yup.string().required('Required'),
});

const SignUpInvite = () => {
  const history = useHistory();
  const user = useSelector((state: RootState) => state.user.user);
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<InviteUserData>({
    defaultValues: INVITE_SIGN_UP_DEFAULT_VALUES,
    mode: 'onChange',
    resolver: yupResolver(schema),
  });
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async (formData: InviteUserData) => {
    try {
      setIsLoading(true);
      const strapi_user = await restFactory.patch<User>(
        `/dj/api/v1/strapi_user/${user.id}/invite_sign_up/`,
        formData
      );
      if (!strapi_user.new_user) {
        history.replace('/authorize');
      }
    } catch (error) {
      toast.error(error as AxiosError);
      setIsLoading(false);
    }
  };

  if (!user.new_user) {
    return <Redirect to="/authorize" />;
  }

  return (
    <Container className="p-0" fluid="xl">
      <BackgroundImages />
      <div className={classnames('row fix-bg-images', styles.formContainer)}>
        <Card className={classnames('pt-5 px-2 px-md-5 shadow', styles.card)}>
          <img className={styles.logo} src={nomadLogo} alt="logo"></img>
          <h1
            className={classnames(
              'mb-3 text-center pt-5 text-uppercase',
              styles.title
            )}
          >
            Sign Up
          </h1>
          <h5
            className={classnames(
              'text-center text-light4 pb-2',
              styles.subtitle
            )}
          >
            Welcome to Nomad Data. Please fill out the below information to get
            started
          </h5>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Card.Body className={classnames('card-body', styles.cardBody)}>
              <div className="form-group">
                <Input
                  placeholder="First Name"
                  type="text"
                  register={register('first_name', { required: true })}
                  error={errors?.first_name?.message}
                  maxLength={64}
                  autoComplete="off"
                  required={true}
                  showErrorBorder={!!errors?.first_name?.message}
                />
              </div>
              <div className="form-group">
                <Input
                  placeholder="Last Name"
                  type="text"
                  register={register('last_name', { required: true })}
                  error={errors?.last_name?.message}
                  maxLength={64}
                  autoComplete="off"
                  required={true}
                  showErrorBorder={!!errors?.last_name?.message}
                />
              </div>
              <div className="form-group">
                <Input
                  placeholder="Job Title"
                  type="text"
                  register={register('job_title', { required: true })}
                  error={errors?.job_title?.message}
                  maxLength={64}
                  autoComplete="off"
                  required={true}
                  showErrorBorder={!!errors?.job_title?.message}
                />
              </div>
              <button
                className={classnames(
                  'btn btn-primary w-100 mb-5 mt-5',
                  styles.saveBtn
                )}
                type="submit"
                disabled={isLoading}
              >
                Continue
              </button>
            </Card.Body>
          </form>
        </Card>
      </div>
    </Container>
  );
};

export default SignUpInvite;
